var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditDarkBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip0_14490_2616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.1665 3.33417H3.33317C2.89114 3.33417 2.46722 3.50977 2.15466 3.82233C1.8421 4.13489 1.6665 4.55881 1.6665 5.00084V16.6675C1.6665 17.1095 1.8421 17.5335 2.15466 17.846C2.46722 18.1586 2.89114 18.3342 3.33317 18.3342H14.9998C15.4419 18.3342 15.8658 18.1586 16.1783 17.846C16.4909 17.5335 16.6665 17.1095 16.6665 16.6675V10.8342M15.4165 2.08417C15.748 1.75265 16.1977 1.56641 16.6665 1.56641C17.1353 1.56641 17.585 1.75265 17.9165 2.08417C18.248 2.41569 18.4343 2.86533 18.4343 3.33417C18.4343 3.80301 18.248 4.25265 17.9165 4.58417L9.99984 12.5008L6.6665 13.3342L7.49984 10.0008L15.4165 2.08417Z",
    stroke: "#0948A1",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14490_2616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDarkBlue);
export default __webpack_public_path__ + "static/media/editDarkBlue.b3f3ac48872361f4c9ef7969712675fe.svg";
export { ForwardRef as ReactComponent };